// utils
import PadItemMatMed from 'app/redux/reducers/pad-model-creator/components-js/pad-item/PadItemMatMed';

const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_ITEM_MATMED';

const initialState = {
  screenData: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_UPDATE`: {
      const { padPrescriptions, padDetails } = action.payload.data;

      const padCreatorMatMed = new PadItemMatMed(state);

      // prettier-ignore
      return padCreatorMatMed
        .update(padPrescriptions, padDetails)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
